"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProductImage = exports.postProductsSearch = exports.getProductsSearch = exports.postProductsValidation = exports.postProductsTempSaveValidation = void 0;
var utils_1 = require("./utils");
function postProductsTempSaveValidation(postProductsRequest) {
    var errorList = [];
    var data = postProductsRequest.data;
    if (!data.mallNo) {
        utils_1.addErrorList(errorList, 'mallNo', 'PRODUCT_MALLNO_ISNULL_ERROR');
    }
    return errorList;
}
exports.postProductsTempSaveValidation = postProductsTempSaveValidation;
function postProductsValidation(postProductsRequest) {
    var errorList = [];
    var data = postProductsRequest.data;
    if (!data.mallNo) {
        utils_1.addErrorList(errorList, 'mallNo', 'PRODUCT_MALLNO_ISNULL_ERROR');
    }
    return errorList;
}
exports.postProductsValidation = postProductsValidation;
function getProductsSearch(productsSearchRequest) {
    var errorList = [];
    var params = productsSearchRequest.params;
    if (!params['periodInfo.type']) {
        utils_1.addErrorList(errorList, 'periodInfo.type', 'PRODUCT_PRODUCTLIST_PERIODINFO_TYPE_ISNULL');
    }
    if (!params['periodInfo.period.startYmdt']) {
        utils_1.addErrorList(errorList, 'periodInfo.period.startYmdt', 'PRODUCT_PRODUCTLIST_PERIODINFO_PERIOD_STARTYMDT_ISNULL');
    }
    if (!params['periodInfo.period.endYmdt']) {
        utils_1.addErrorList(errorList, 'periodInfo.period.endYmdt', 'PRODUCT_PRODUCTLIST_PERIODINFO_PERIOD_ENDYMDT_ISNULL');
    }
    return errorList;
}
exports.getProductsSearch = getProductsSearch;
function postProductsSearch(productsSearchPostRequest) {
    var errorList = [];
    var data = productsSearchPostRequest.data;
    if (!data['periodInfo.type']) {
        utils_1.addErrorList(errorList, 'periodInfo.type', 'PRODUCT_PRODUCTLIST_PERIODINFO_TYPE_ISNULL');
    }
    if (!data['periodInfo.period.startYmdt']) {
        utils_1.addErrorList(errorList, 'periodInfo.period.startYmdt', 'PRODUCT_PRODUCTLIST_PERIODINFO_PERIOD_STARTYMDT_ISNULL');
    }
    if (!data['periodInfo.period.endYmdt']) {
        utils_1.addErrorList(errorList, 'periodInfo.period.endYmdt', 'PRODUCT_PRODUCTLIST_PERIODINFO_PERIOD_ENDYMDT_ISNULL');
    }
    return errorList;
}
exports.postProductsSearch = postProductsSearch;
function getProductImage(getProductImageRequest) {
    var errorList = [];
    var params = getProductImageRequest.params;
    if (!params.productNo) {
        utils_1.addErrorList(errorList, 'productNo', 'PRODUCT_PRODUCTIMAGE_PRODUCTNO_TYPE_ISNULL');
    }
    return errorList;
}
exports.getProductImage = getProductImage;
